import axios from "axios"
import { doc, setDoc } from "firebase/firestore"
import { db } from "../Config/firebase"


export const xenditPayment=async(data,total,uid,bank)=>{

	const newUrl = `https://us-central1-cloudkitchen-id.cloudfunctions.net/createPayment`
	const dataArr={
		company:'EPD',
		bank_code:bank,
		name:uid,
		expected_amount:parseInt(total) ,
		data
		}
		console.log(dataArr,'ini datanya')
	const result = await axios.post(newUrl,dataArr)
	if(result.status){
		await setDoc(doc(db, "cart", uid), {})
		return result
	} 
	else return null
}

